import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { doPost } from '../../../config/fetchWrapper'
import { urls } from '../../endPoints'
import { encryptData } from '../../../helpers/encrypt/crypto-encrypt'

export const OtpAction = createAsyncThunk('otp', async (arg, { rejectWithValue }) => {
    try {
        const response = await doPost(urls?.otp, arg)

        let license = encryptData({
            accessLimits: JSON.stringify(response?.user?.accessLimits || { playBooks: [] }),
            planDetails: JSON.stringify(response?.user?.currentPlan || ''),
        })
        sessionStorage.license = license

        let eqlwoer = encryptData({
            pilotUser: response.user?.roleDetails?.isPilotUser,
            role: response.user?.role,
            roleOptions: JSON.stringify(response.user.roleDetails.role),
        })
        sessionStorage.eqlwoer = eqlwoer

        let rqewseu = encryptData({
            userId: response.user._id,
            userName: response.user && response.user.name,
            usermail: response.user && response.user.email,
        })
        sessionStorage.rqewseu = rqewseu
        
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

const OtpSlice = createSlice({
    name: 'otp',
    initialState: {
        isLoading: false,
        otp: {},
        error: null,
        success: false,
    },
    reducers: {
        OtpReset: () => {
            return {
                isLoading: false,
                error: null,
                success: false,
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(OtpAction.pending, (state) => {
                state.isLoading = true
                state.error = null
                state.success = false
            })
            .addCase(OtpAction.fulfilled, (state, action) => {
                state.isLoading = false
                state.otp = action.payload
                state.error = null
                state.success = true
            })
            .addCase(OtpAction.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
                state.success = false
            })
    },
})

export const { OtpReset } = OtpSlice.actions
export default OtpSlice.reducer
